import { render } from "./CurrencyView.vue?vue&type=template&id=ca9eb6b6&scoped=true&ts=true"
import script from "./CurrencyView.vue?vue&type=script&lang=ts"
export * from "./CurrencyView.vue?vue&type=script&lang=ts"

import "./CurrencyView.vue?vue&type=style&index=0&id=ca9eb6b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca9eb6b6"]])

export default __exports__